
/* injects from baggage-loader */
require('./credit-pre-approval-modal.component.html');

import angular from 'angular';

angular.module('AaApp.Opp').component('creditPreApprovalModal', {
    templateUrl: '/app/components/deal-sheet/modals/credit-pre-approval-modal.component.html',
    bindings: {
        close: '&',
        dismiss: '&',
        resolve: '<'
    }
});
